import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "../../../Header";
import { ToastContainer } from "react-toastify";
import { BiArrowBack, BiPencil, BiTrash, BiPlus, BiX } from "react-icons/bi";
import useFetchGet from "../hooks/useFetchGet";
import useFetchPost from "../hooks/useFetchPost";
import DatePicker from "rsuite/DatePicker";

import SelectPicker from "rsuite/SelectPicker";
import CheckPicker from "rsuite/CheckPicker";

import Toggle from "rsuite/Toggle";
import "rsuite/CheckPicker/styles/index.css";
// import "rsuite/dist/rsuite.min.css";
import "../../../assets/css/rsuite.css";
import moment from "moment";
import { toast } from "react-toastify";
import Autocomplete from '../../AutoComplete.js'

import { useHistory, useParams, useLocation } from "react-router-dom";
import { getCookie } from "../customer/Utility.js";
const currentUnixTime = new Date().toLocaleDateString("en-CA");
const dealStates = ["Warm", "Hot", "Cold"].map((item) => ({ label: item, value: item }));
const dealPipeline = ["Sales Pipeline", "Account Management Pipeline", "Prepales Pipeline"].map((item) => ({ label: item, value: item }));
const dealStage = ["Discovery Call",
	"Evaluating Platform",
	"Proposal Submitted",
	"Negotiation / Discussion",
	"Contract Won / Signup Complete",
	"Closed lost",
	"Delayed",
	"RFP"].map((item) => ({ label: item, value: item }));


const AddDeal = () => {

	const { fetchData } = useFetchGet();
	const { fetchPostData } = useFetchPost();
	const location = useLocation();
	//const deal_uuid = match.params.deal_uuid;
	const { deal_uuid: dealUuid } = useParams();
	const [isEdit, setIsEdit] = useState(false);
	const [customerData, setCustomerData] = useState([]);
	const [customerSearchValue, setCustomerSearchValue] = useState("");
	// adding employee data
	const [employeeData, setEmployeeData] = useState(null);

	const [productData, setProductData] = useState([]);
	// const [newprodData, setNewProdData] = useState([])
	const [stateData, setStateData] = useState([]);
	const [customerLoading, setCustomerLoading] = useState(false);
	const [stateLoading, setStateLoading] = useState(false);
	const [usersList, setUsersList] = useState([]);
	
	const history = useHistory();
	const muviUserUuid = getCookie("muvi_useruuid");

	//necessory
	const [inputValue, setInputValue] = useState({
		// customer_id: "",
		mautic_id: "",
		product: [],
		deal_name: "",
		deal_value: "",
		deal_state: "",
		deal_description: "",
		deal_status: true,
		deal_pipeline: "",
		deal_owner: "",
		deal_stage: "Discovery Call",
	});
	const [rows, setRows] = useState([
		{
			milestone_sl_no: 1,
			milestone_desc: "",
			milestone_amount: "",
			milestone_due: null,
			milestone_status: "Draft",
			isEditable: false,
		},
	]);
	const [tepDates, setTepDates] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const [isDisable, setIsDisable] = useState(false);
	const [customerDetails, setCustomerDetails] = useState({});
	const [error, setError] = useState({});

	useEffect(() => {
		fetchUsersList();
	}, [])


	const timerRef = useRef(null);

	// Get mautic_id from query params
	const queryParams = new URLSearchParams(location.search);
	const customer_identifier = queryParams.get("mautic_id");
		useEffect(() => {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				deal_owner: muviUserUuid,
			}));
	
		}, [muviUserUuid]);

	// Handle query param mautic_id on mount
	useEffect(() => {
		if (customer_identifier) {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				mautic_id: customer_identifier,
			}));
		}
		if(customer_identifier){
			fetchCustomerDetails()
		}
	}, [customer_identifier]);

	useEffect(() => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}

		timerRef.current = setTimeout(() => {
			getCustomers(customerSearchValue);
		}, 1000);
	}, [customerSearchValue])

	const fetchCustomerDetails = async () => {
		//TODO: Get this from ENV
		const mauticURL =
			process.env.REACT_APP_CRM_ADMIN

		let url = mauticURL;

		if (!isNaN(customer_identifier)) {
			console.log("Fetching by Mautic ID");
			url += "/api/crm/contact/id/" + customer_identifier;
		} else if (/\S+@\S+\.\S+/.test(customer_identifier)) {
			console.log("Fetching by email");
			url += "/api/crm/contact/email/" + customer_identifier;
		} else {
			console.log("Fetching by customer identifier");
			url += "/api/crm/contact/customer-id/" + customer_identifier;
		}

		const response = await fetch(url, {
			method: "POST",
		});
		const findresponse = await response.json();

		if (findresponse && findresponse.code === 200) {
			const data = findresponse.data;

			if (!data) return;
			const {
				name,
				associated_products,
				other_contacts = [],
			} = data;
			// Set customer details
			setCustomerDetails({
				...data,
			});
			setCustomerSearchValue(name);
			// setInputValue()

		}
	};

	const getCustomers = async (keyword) => {
		let retData = [];

		if (!keyword) {
			setCustomerLoading(false);
			setCustomerData([]);
			return;
		}

		if (keyword.trim().length < 1) {
			setCustomerLoading(false);
			setCustomerData([]);
			return;
		}

		setCustomerLoading(true);
		try {
			let responseData;

			if (keyword.trim().length >= 1) {
				responseData = await fetchData(`${process.env.REACT_APP_CRM_ADMIN}/api/crm/get-customer-list?keyword=${keyword}`);
			} else {
				responseData = await fetchData(`${process.env.REACT_APP_CRM_ADMIN}/api/crm/get-customer-list`);
			}

			if (responseData.success == true) {
				retData = await responseData.data;
				setCustomerLoading(false);
			} else {
				setCustomerLoading(false);
			}

			const filteredData = retData.map((item) => ({
				label: item.name,
				value: item.mautic_id,
			}));
			// console.log(filteredData, customerData, retData, responseData.data,  "filteredDatafilteredData")
			setCustomerData(filteredData);
		} catch (error) {
			setCustomerLoading(false);
			setCustomerData([]);
			console.error("Error:", error);
		}
	};

	const getProduct = async () => {
		try {
			//DLOa1fdPDY9LN7RYOIyBhMKb161NCSSq
			const responseProductData = await fetchData(`${process.env.REACT_APP_CRM}/crm/product/list`);
			//console.log("ProductList", responseProductData);
			setProductData(responseProductData);
		} catch (error) {
			console.error("Error:", error);
		}
	};

	const fetchUsersList = () => {
		fetch(`${process.env.REACT_APP_CRM}/user-list`, {
			method: "POST",
		})
			.then((resp) => {
				return resp.json();
			})
			.then((data) => {
				if (data.code == 200) {
					const userList = Object.values(data.data); // Convert object to array

					// Filter users with is_active === 1 and map to desired format
					const formattedUserList = userList
						.filter(user => user.is_active === 1)
						.map(user => ({
							label: user.name,
							value: user.user_uuid
						}));

					setUsersList(formattedUserList);
				}
			});
	};

	const getDealState = async () => {
		setStateLoading(true);
		try {
			const responseData = await fetchData(`${process.env.REACT_APP_CRM}/crm/get-deal-state-list`);
			if (responseData.code == 200) {
				setStateData(responseData.data);
				setStateLoading(false);
			}
		} catch (error) {
			setStateLoading(false);
			console.error("Error:", error);
		}
	};



	const getDealDetails = async () => {
		const requestBody = {
			deal_id: dealUuid,
		};
		let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/deal-detail";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, requestBody, true);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}
		if (responseData && responseData.code == 200) {
			const data = responseData.data;
			document.title = `Intranet | ${data.deal_name}`;
			setInputValue({
				deal_id: data.deal_id,
				deal_uuid: data.deal_uuid,
				// customer_id: data.customer_id,
				mautic_id: data.mautic_id,
				product: data.product,
				deal_name: data.deal_name,
				deal_value: data.deal_value,
				deal_state: data.deal_state,
				deal_description: data.deal_description,
				deal_status: data.deal_status,
				deal_pipeline: data.deal_pipeline,
				deal_owner: data.deal_owner,
				deal_stage: data.deal_stage,
			});
			setCustomerSearchValue(data.company_name);
			if (data.mautic_id && data.name) {
				setCustomerData([
					{
						mautic_id: data.mautic_id,
						company_name: data.name
					}
				]);
				setCustomerSearchValue(data.name);
			}

			const formattedMilestones = data.milestones
				? data.milestones.map((milestone) => ({
					milestone_id: milestone.milestone_id,
					milestone_uuid: milestone.milestone_uuid,
					milestone_sl_no: milestone.milestone_sl_no,
					milestone_desc: milestone.milestone_desc,
					milestone_amount: milestone.milestone_amount,
					milestone_due: new Date(milestone.milestone_due * 1000),
					milestone_status: milestone.milestone_status,
					milestone_status_temp: milestone.milestone_status,
					milestone_amount_temp: milestone.milestone_amount,
					isEditable: true,
				}))
				: [];

			setRows(formattedMilestones);
		}
		else {
			history.push('/deals/list')
		}
	};

	useEffect(() => {
		getProduct();
		if (dealUuid) {
			getDealDetails();
			//getCustomers();
			getDealState();
			setIsDisable(true);
			setIsEdit(true);
			document.title = `Intranet | Edit Deal`;
		} else {
			document.title = "Intranet | Add Deal";
			//getCustomers();
			setIsDisable(false);
			setIsEdit(false);
		}
	}, [dealUuid]);

	const handleCutomerChange = (item) => {
		if (item && item.value == '') {
			setCustomerSearchValue("");
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				mautic_id: "",
			}));
			return;
		}
		setCustomerSearchValue(item.label)
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			mautic_id: item.value,
		}));
	}

	const handleSelectChange = (name) => (value) => {
		if (name === "mautic_id") {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				mautic_id: value.value,
			}));
		} else {
			setInputValue((prevInputValue) => ({
				...prevInputValue,
				[name]: value,
			}));
		}


		let validationErrors = {};
		if (name == "product_key") {
			validationErrors.product_key = "";
			document.querySelector(".product-key").querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}
		if (name == "deal_state") {
			validationErrors.deal_state = "";
			document.querySelector(".deal-state").querySelector(`.rs-picker-toggle`).style.borderColor = "";
		}
		setError(validationErrors);
	};

	const handleDealInputChange = (event) => {
		const { name, value } = event.target;
		let formattedValue = value;

		if (name === "deal_value") {
			// Prevent non-numeric characters except a single dot
			formattedValue = formattedValue.replace(/[^0-9.]/g, '');

			// Ensure only one dot is present
			const parts = formattedValue.split('.');
			if (parts.length > 2) {
				formattedValue = parts[0] + '.' + parts.slice(1).join('');
			}

			// Restrict to two decimal places
			if (parts.length === 2 && parts[1].length > 2) {
				formattedValue = parts[0] + '.' + parts[1].slice(0, 2);
			}

			// Prevent leading dot (convert ".5" → "0.5")
			if (formattedValue.startsWith('.')) {
				formattedValue = '0' + formattedValue;
			}
		}

		setInputValue((prevInputValue) => ({
			...prevInputValue,
			[name]: formattedValue,
		}));

		let validationErrors = {};
		let totalMilestoneAmount;
		let hasError = false;

		if (name === "deal_value") {
			const updatedRows = [...rows];
			totalMilestoneAmount = updatedRows.reduce((sum, milestone) => {
				return sum + Number(milestone.milestone_amount);
			}, 0);

			if (Number(formattedValue) === 0 || formattedValue === '') {
				validationErrors.deal_value = "Enter Deal Value";
				document.querySelector(".deal-value").style.borderColor = "red";
				hasError = true;
			} else {
				validationErrors.deal_value = "";
				document.querySelector(".deal-value").style.borderColor = "";
			}
		}

		setError(validationErrors);

		// If any error exists, return early
		if (hasError || Object.values(validationErrors).some((error) => error !== "")) {
			return;
		}
	};


	const handleInputChange = (index, event) => {
		const { name, value } = event.target;

		let formattedValue = value;
		let hasError = false;

		const updatedRows = rows.map((row) => ({ ...row }));

		/* ---------------- FORMAT MILESTONE AMOUNT ---------------- */
		if (name === "milestone_amount") {
			formattedValue = formattedValue.replace(/[^0-9.]/g, '');

			const parts = formattedValue.split('.');
			if (parts.length > 2) {
				formattedValue = parts[0] + '.' + parts.slice(1).join('');
			}

			if (parts.length === 2 && parts[1].length > 2) {
				formattedValue = parts[0] + '.' + parts[1].slice(0, 2);
			}

			if (formattedValue.startsWith('.')) {
				formattedValue = '0' + formattedValue;
			}
		}

		updatedRows[index][name] = formattedValue;

		/* ---------------- STATUS CHANGE LOGIC ---------------- */
		if (name === "milestone_amount") {
			if (
				updatedRows[index].milestone_amount_temp === formattedValue
			) {
				updatedRows[index].milestone_status =
					updatedRows[index].milestone_status_temp;
			} else {
				updatedRows[index].milestone_status = "Draft";
			}
		}

		/* ---------------- VALIDATION ---------------- */
		if (name === "milestone_amount") {
			let totalMilestoneAmount = 0;

			for (let i = 0; i < updatedRows.length; i++) {
				totalMilestoneAmount += Number(updatedRows[i].milestone_amount || 0);
			}

			if (formattedValue === "" || Number(formattedValue) === 0) {
				updatedRows[index].milestone_amount_error = "Enter Amount";
				hasError = true;
			} else {
				updatedRows[index].milestone_amount_error = "";
			}


			if (
				Number(inputValue.deal_value) >= 1 &&
				totalMilestoneAmount === Number(inputValue.deal_value)
			) {
				for (let i = 0; i < updatedRows.length; i++) {
					updatedRows[i].milestone_amount_error = "";
				}
				setError({ deal_value: "" });
			}
		}

		if (name === "milestone_desc") {
			if (!formattedValue.trim()) {
				updatedRows[index].milestone_desc_error = "Enter Description";
				hasError = true;
			} else if (formattedValue.trim().length > 500) {
				updatedRows[index].milestone_desc_error =
					"Description Exceeds 500 Characters.";
				hasError = true;
			} else {
				updatedRows[index].milestone_desc_error = "";
			}
		}

		if (name === "milestone_due") {
			if (!formattedValue) {
				updatedRows[index].milestone_due_error = "Select Due Date";
				hasError = true;
			} else {
				updatedRows[index].milestone_due_error = "";
			}
		}

		/* ---------------- FINAL STATE UPDATE ---------------- */
		setRows(updatedRows);

		if (hasError) {
			return;
		}
	};


	const changeDealStatus = (value, event) => {
		setInputValue((prevInputValue) => ({
			...prevInputValue,
			["deal_status"]: value, // Update inputValue with the selected values
		}));
	};
	const handleAddRow = () => {
		setRows([
			...rows,
			{
				milestone_sl_no: rows.length + 1,
				milestone_desc: "",
				milestone_amount: "",
				milestone_due: null,
				milestone_status: "Draft",
			},
		]);
	};
	const handleChangeDate = (index, name) => (value) => {
		//console.log(value);
		// console.log(new Date("2023-02-22"));
		if (!value) {
			setRows((prevRows) =>
				prevRows.map((row, rowIndex) => {
					if (rowIndex === index) {
						return { ...row, [name]: "" };
					}
					return row;
				})
			);
			setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: "" }));
		} else {
			const formattedDates = moment(value).format("YYYY-MM-DD");
			setRows((prevRows) =>
				prevRows.map((row, rowIndex) => {
					if (rowIndex === index) {
						// Clear validation error and update the date
						return { ...row, [name]: formattedDates, milestone_due_error: "" };
					}
					return row;
				})
			);
			setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: value }));
			document
				.querySelector(`.milestone-due-${index}`)
				.querySelector('div[name="milestone_due"]').style.borderColor = "";
		}
	};
	const handleRemoveRow = (index) => {
		const updatedRows = [...rows];
		updatedRows.splice(index, 1);
		setRows(updatedRows);
	};
	const editHandler = (index) => {
		setRows((prevRows) =>
			prevRows.map((row, rowIndex) => {
				if (rowIndex === index) {
					return { ...row, isEditable: false }; //milestone_status: "Due",
				}
				return row;
			})
		);
	};
	const handleCancel = () => {
		
		window.parent.location = "/deals/list"; //window.parent.location.href;
	};
	
	const handleSubmit = async () => {


		let validationErrors = {};
		let hasError = false;

		/* ---------------- DEAL VALIDATION ---------------- */

		if (!inputValue.mautic_id) {
			validationErrors.mautic_id = "Select Contact Name";
			hasError = true;
		}

		if (!inputValue.product || inputValue.product.length === 0) {
			validationErrors.product_key = "Select Product Name";
			hasError = true;
		}
		if (!inputValue.deal_pipeline || !inputValue.deal_pipeline.trim()) {
			validationErrors.deal_pipeline = "Select Deal Pipeline";
			hasError = true;
		}


		if (!inputValue.deal_owner || !inputValue.deal_owner.trim()) {
			validationErrors.deal_owner = "Select Deal Owner";
			hasError = true;
		}
		if (!inputValue.deal_stage || !inputValue.deal_stage.trim()) {
			validationErrors.deal_stage = "Select Deal Stage";
			hasError = true;
		}
		// if (!inputValue.customisation_details || !inputValue.customisation_details.trim()) {
		// 	validationErrors.customisation_details = "Enter Customisation Details";
		// 	hasError = true;
		// }
		if (!inputValue.deal_name || !inputValue.deal_name.trim()) {
			validationErrors.deal_name = "Enter Deal Name";
			hasError = true;
		} else if (inputValue.deal_name.length > 100) {
			validationErrors.deal_name = "Deal Name Exceeds 100 Characters.";
			hasError = true;
		}

		if (!inputValue.deal_value || Number(inputValue.deal_value) <= 0) {
			validationErrors.deal_value = "Enter Deal Value";
			hasError = true;
		} else {
			let totalMilestoneAmount = 0;

			for (let i = 0; i < rows.length; i++) {
				totalMilestoneAmount += Number(rows[i].milestone_amount || 0);
			}

			if (totalMilestoneAmount !== Number(inputValue.deal_value)) {
				validationErrors.deal_value =
					"The Amount should be equal to the total Milestone Value.";
				hasError = true;
			}
		}

		if (!inputValue.deal_state || !inputValue.deal_state.trim()) {
			validationErrors.deal_state = "Select Deal State";
			hasError = true;
		}

		/* ---------------- MILESTONE VALIDATION ---------------- */

		if (!rows || rows.length === 0) {
			validationErrors.milestone =
				"You need to add at least one milestone.";
			hasError = true;
		}

		const updatedRows = rows.map((row) => ({
			...row,
			milestone_desc_error: "",
			milestone_amount_error: "",
			milestone_due_error: "",
		}));

		for (let i = 0; i < updatedRows.length; i++) {
			const row = updatedRows[i];

			if (!row.milestone_desc || !row.milestone_desc.trim()) {
				row.milestone_desc_error = "Enter Description";
				validationErrors[`milestone_desc_${i}`] = "Enter Description";
				hasError = true;
			} else if (row.milestone_desc.length > 500) {
				row.milestone_desc_error =
					"Description Exceeds 500 Characters.";
				validationErrors[`milestone_desc_${i}`] =
					"Description Exceeds 500 Characters.";
				hasError = true;
			}

			if (
				!row.milestone_amount ||
				isNaN(row.milestone_amount) ||
				Number(row.milestone_amount) <= 0
			) {
				row.milestone_amount_error = "Enter a valid Amount";
				validationErrors[`milestone_amount_${i}`] =
					"Enter a valid Amount";
				hasError = true;
			}

			if (!row.milestone_due) {
				row.milestone_due_error = "Select Due Date";
				validationErrors[`milestone_due_${i}`] =
					"Select Due Date";
				hasError = true;
			}
		}

		setError(validationErrors);
		setRows(updatedRows);

		if (hasError) {
			return;
		}

		/* ---------------- PREPARE PAYLOAD ---------------- */

		setIsSaving(true);

		const formattedRows = updatedRows.map((item) => ({
			...item,
			milestone_due: new Date(item.milestone_due).toLocaleDateString("en-CA"),
		}));

		const requestBody = {
			...inputValue,
			milestone: formattedRows,
			user_uuid: muviUserUuid,
			mautic_id: inputValue.mautic_id,
		};

		let crmStagingUrl =
			process.env.REACT_APP_CRM + "/crm/store-deal-data";

		let responseData;
		try {
			responseData = await fetchPostData(
				crmStagingUrl,
				requestBody,
				true
			);
		} catch (error) {
			console.error("Error:", error);
			setIsSaving(false);
			return;
		}

		if (responseData && responseData.code === 200) {
			setIsSaving(false);
			toast.success(responseData.message, {
				position: "top-right",
				autoClose: 1000,
			});

			setInputValue({
				mautic_id: "",
				product: [],
				deal_name: "",
				deal_value: "",
				deal_state: "",
				deal_description: "",
			});

			setRows([]);
			setTimeout(() => history.push("/deals/list"), 200);
		} else {
			setIsSaving(false);
			toast.error(
				responseData && responseData.message
					? responseData.message
					: "An error occurred",
				{ position: "top-right", autoClose: 1000 }
			);
		}
	};


	const backHandler = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			history.replace("/deals/list");
		}
	};


	function convertUnixTimeStampToDate(unixTimestamp) {
		if (unixTimestamp) {
			const date = new Date(unixTimestamp).toLocaleDateString("en-CA");
			return date;
		}
	}
	return (
		<div>
			<Header brecum_name="Deals" brecum_page={isEdit ? "Edit Deal" : "Add Deal"} />
			<ToastContainer />

			<div className="right_col">
				<div className="customer-wrap">
					<div className="page-top" style={{ padding: "0px 0px" }}>
						<div className="containerfull title" style={{ padding: "0px 0px" }}>
							<div className="row">
								<div className="col-md-11">
									<div className="row">
										<div className="col-md-6">
											<div className="mt-10">
												<div className="d-flex align-items-center">
													<h2> {isEdit ? "Edit" : "Add"} Deal</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Serch Box */}
								<div className="col-md-1">
									<div className="d-flex12">
										<div
											className="toogle-btn"
											style={{ float: "right", margin: "5px 5px", height: "37px" }}
											onClick={backHandler}
										>
											<span style={{ fontSize: "18px", lineHeight: "20px", color: "#7a7a7a" }}>
												<BiArrowBack />
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="body-content row" style={{ width: "100%", padding: "10px" }}>
						<div className="col-md-12">
							{/* Add New Deal Form */}
							<div className="containerfull">
								<div className="row">
									<div className="col-md-6 col-lg-6">
										<div className="inputGroup">
											<label className="input-label">
												Contact Name <span className="star">*</span>
											</label>
											<Autocomplete
												name="mautic_id"
												value={customerSearchValue}
												items={customerData}
												valueProperty="value"
												labelProperty="label"
												isLoading={customerLoading}
												placeholder={"Select Contact Name"}
												onSelect={(value, item) => {
													handleCutomerChange(item)
												}}
												onChange={(event, value) => {
													setCustomerSearchValue(value)
												}}
											/>
											
											{error && <div className="text-danger">{error.mautic_id}</div>}
										</div>
									</div>
									{/* Product */}
									<div className="col-md-6 col-lg-6">
										<div className="inputGroup">
											<label className="input-label">
												Product <span className="star">*</span>
											</label>
											<CheckPicker
												data={
													productData
														.map((item) => ({
															label: item.product_name,
															value: item.product_key,
														}))}
												className="product-key"
												name="product"
												value={inputValue.product}
												onChange={handleSelectChange("product")}
												style={{
													width: "100%",
													zIndex: 1050,
												}}
												block={true}
												searchable={false}
												placeholder="Select Product"
												disabled={isDisable && true}
											/>

											{error && <div className="text-danger">{error.product_key}</div>}
										</div>
									</div>
								</div>
								{/* Deal Name and Value */}
								<div className="row mt20">
									<div className="col-md-6 col-lg-6">
										<div className="inputGroup">
											<label className="input-label">
												Deal Name <span className="star">*</span>
											</label>
											<input
												type="text"
												className="form-control deal-name"
												id="feature"
												autoComplete="off"
												placeholder="Enter Deal Name"
												name="deal_name"
												value={inputValue.deal_name}
												onChange={(event) => handleDealInputChange(event)}
											/>
											{error && <div className="text-danger">{error.deal_name}</div>}
										</div>
									</div>

									<div className="col-md-3 col-lg-3">
										<div className="inputGroup">
											<label className="input-label">
												Deal Value ($) <span className="star">*</span>{" "}
											</label>
											<input
												type="text"
												className="form-control deal-value"
												id="feature"
												autoComplete="off"
												placeholder="Enter Deal Value"
												name="deal_value"
												value={inputValue.deal_value}
												onChange={(event) => handleDealInputChange(event)}
						
											/>

											{error && <div className="text-danger">{error.deal_value}</div>}
										</div>
									</div>
									<div className="col-md-3 col-lg-3">
										<div className="inputGroup">
											<label className="input-label">
												Deal State <span className="star">*</span>
											</label>
											<SelectPicker
												data={dealStates}
												name="deal_state"
												className="deal-state"
												value={inputValue.deal_state}
												onChange={handleSelectChange("deal_state")}
												style={{
													width: "100%",
													zIndex: 1050,
												}}
												block={true}
												searchable={false}
												placeholder="Select Deal State"

											/>
											{error && <div className="text-danger">{error.deal_state}</div>}
										</div>
									</div>
								</div>

								{/* Pipeline, Deal Owner, Deal stage */}
								<div className="row mt20">
									{/* Pipeline */}
									<div className="col-md-6 col-lg-6">
										<div className="inputGroup">
											<label className="input-label">
												Pipeline <span className="star">*</span>
											</label>
											<SelectPicker
												data={dealPipeline}
												name="deal_pipeline"
												className="deal-pipeline"
												value={inputValue.deal_pipeline}
												onChange={handleSelectChange("deal_pipeline")}
												style={{
													width: "100%",
													zIndex: 1050,
												}}
												block={true}
												searchable={false}
												placeholder="Select Deal Pipeline"

											/>
											{error && <div className="text-danger">{error.deal_pipeline}</div>}
										</div>
									</div>
									{/* deal owner */}
									<div className="col-md-3 col-lg-3">
										<div className="inputGroup">
											<label className="input-label">
												Deal Owner <span className="star">*</span>
											</label>
											<SelectPicker
												data={usersList}
												name="deal_owner"
												virtualized
												searchBy="label"
												className="deal-owner"
												value={inputValue.deal_owner}
												onChange={handleSelectChange("deal_owner")}
												style={{
													width: "100%",
													zIndex: 1050,
												}}
												block={true}
												searchable={true}
												placeholder="Select Deal Owner"

											/>
											{error && <div className="text-danger">{error.deal_owner}</div>}
										</div>
									</div>

									<div className="col-md-3 col-lg-3">
										<div className="inputGroup">
											<label className="input-label">
												Deal Stage <span className="star">*</span>
											</label>
											<SelectPicker
												data={dealStage}
												name="deal_stage"
												className="deal-stage"
												value={inputValue.deal_stage}
												onChange={handleSelectChange("deal_stage")}
												style={{
													width: "100%",
													zIndex: 1050,
												}}
												block={true}
												searchable={false}
												placeholder="Select Deal Stage"
											/>
											{error && <div className="text-danger">{error.deal_stage}</div>}
										</div>
									</div>
								</div>


								{/* Description */}
								<div className="row mt20">
									<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div className="inputGroup">
											<label>Description</label>
											<textarea
												className="form-control deal-description"
												id="exampleFormControlTextarea1"
												rows="3"
												autoComplete="off"
												placeholder="Enter Description"
												name="deal_description"
												value={inputValue.deal_description}
												onChange={(event) => handleDealInputChange(event)}
											></textarea>
											{error && <div className="text-danger">{error.deal_description}</div>}
										</div>
									</div>
								</div>

							</div>

							{/* Milestone */}
							<div className="containerfull mt20">
								<div className="informationTitle" style={styleObj.informationTitle}>
									Payment Schedule
								</div>
								{error && <div className="text-danger">{error.milestone_amount_total_error}</div>}
								<div className="table-wrap table-milestone">
									<table
										className="deal-table"
										style={{
											tableLayout: "fixed",
											borderCollapse: "separate",
											borderSpacing: "0 10px",
											width: "100%",
											minWidth: 0,
										}}
									>
										<thead>
											<tr>
												<th style={styleObj.intra_col_7}>Milestone</th>
												<th style={styleObj.intra_col_15}>Description</th>
												<th style={styleObj.intra_col_15}>Amount ($)</th>
												<th style={styleObj.intra_col_10}>Due Date</th>
												<th style={styleObj.intra_col_10}>Payment Status</th>
											</tr>
										</thead>
										<tbody>
											{rows.map((row, index) => (
												<tr key={row.milestone_sl_no}>
													<td style={{ borderRight: "none" }}>{row.milestone_sl_no}</td>
													<td style={{ borderRight: "none", borderLeft: "none" }}>
														<input
															type="text"
															className={`form-control milestone-desc-${index}`}
															id="feature"
															autoComplete="off"
															placeholder="Enter Description"
															name="milestone_desc"
															value={row.milestone_desc}
															onChange={(event) => handleInputChange(index, event)}
															disabled={row.isEditable && true}
														/>
														{row && (
															<div className="text-danger">{row.milestone_desc_error}</div>
														)}
													</td>
													<td style={{ borderRight: "none", borderLeft: "none" }}>
														<input
															type="text"
															className={`form-control milestone-amount-${index}`}
															id="feature"
															autoComplete="off"
															placeholder="Enter Amount"
															name="milestone_amount"
															value={row.milestone_amount}
															onChange={(event) => handleInputChange(index, event)}

															disabled={row.isEditable && true}
														/>
														{row && (
															<div className="text-danger">{row.milestone_amount_error}</div>
														)}
													</td>

													<td style={{ borderRight: "none", borderLeft: "none" }}>
														<div className="inputGroup">
															<DatePicker
																className={`milestone-due-${index}`}
																name="milestone_due"
																value={
																	tepDates[index] ||
																	(row.milestone_due && row.milestone_due)
																}
																onChange={handleChangeDate(index, "milestone_due")}
																disabled={row.isEditable && true}
																oneTap
															/>
															{row && (
																<div className="text-danger">{row.milestone_due_error}</div>
															)}
														</div>
													</td>
													<td
														style={{
															borderLeft: "none",
														}}
													>
														<div
															style={{
																display: "flex",
																flexDirection: "row",
																justifyContent: "space-between",
																alignItems: "center",
															}}
														>
															{row.milestone_status ? (
																row.milestone_status === "Paid" ? (
																	<p className="bagde-customer">Paid</p>
																) : row.milestone_status === "Due" ? (
																	new Date(currentUnixTime) >
																		new Date(
																			convertUnixTimeStampToDate(row.milestone_due)
																		) ? (
																		<p className="bagde-danger">Overdue</p>
																	) : (
																		<p className="bagde-warning">Due</p>
																	)
																) : row.milestone_status == "Lost" ? (
																	<p className="bagde-internal">Lost</p>
																) : (
																	<p className="badge-yellow">Draft</p>
																)
															) : (
																""
															)}
															{/* <BiX style={{ fontSize: "18px", marginRight: "10px", float: "right" }} /> */}
															{isEdit &&
																(row.milestone_status == "Draft" ||
																	row.milestone_status == "Overdue" ||
																	row.milestone_status == "Due") && (
																	<span style={{ float: "right" }}>
																		<BiPencil
																			style={{
																				fontSize: "18px",
																				marginRight: "10px",
																			}}
																			onClick={() => editHandler(index)}
																		/>
																		<BiTrash
																			style={{
																				fontSize: "18px",
																				marginRight: "10px",
																			}}
																			onClick={() => handleRemoveRow(index)}
																		/>
																	</span>
																)}

															{!isEdit && (
																<span style={{ float: "right" }}>
																	<BiTrash
																		style={{ fontSize: "18px", marginRight: "10px" }}
																		onClick={() => handleRemoveRow(index)}
																	/>
																</span>
															)}
														</div>
													</td>
												</tr>
											))}
											{error && error.milestone ? (
												<tr>
													<td colSpan={5}>
														{error && <div className="text-danger">{error.milestone}</div>}
													</td>
												</tr>
											) : (
												""
											)}
										</tbody>
									</table>
									<div
										className="d-flex"
										style={{
											padding: "1rem .5rem",
											color: "#1675e0",
											fontSize: "11px",
											fontWeight: "500",
											cursor: "pointer",
											width: "fit-content",
										}}
										onClick={handleAddRow}
									>
										<BiPlus style={{ fontSize: "16px" }} /> Add More Milestone
									</div>
								</div>
							</div>

							<div className="row mt20">
								<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									{isEdit && (
										<div className="addFeatureBtn-Group" style={{ float: "left" }}>
											<label className="input-label">Deal Status &nbsp;</label>

											<Toggle
												size="md"
												checkedChildren="Open"
												unCheckedChildren="Close"
												checked={inputValue.deal_status}
												onChange={(value, event) => changeDealStatus(value, event)}
											/>
										</div>
									)}
								</div>
							</div>
							<div className="row mt30">
								<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div className="addFeatureBtn-Group" style={{ float: "left" }}>
										<button
											type="submit"
											className="btn btn-primary"
											onClick={handleSubmit}
											disabled={isSaving}
										>
											{isSaving ? "Saving..." : "Save"}
										</button>
										<button className="btn btn-blue" onClick={handleCancel}>
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	);
};

const styleObj = {
	informationTitle: {
		fontWeight: 500,
		fontSize: "14px",
		color: "#333",
		textTransform: "capitalize",
		fontFamily: "Poppins-Medium",
		padding: "10px 0",
	},
	intra_col_5: {
		width: "5%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_7: {
		width: "7%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_10: {
		width: "10%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_15: {
		width: "15%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_20: {
		width: "20%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_2: {
		width: "2%",
	},
};

export default AddDeal;



// WEBPACK FOOTER //
// ./src/components/crm/deals/AddDeal.js